<template>
  <Navbar title="confirm vehicle" />
  <div class="confirm-vehicle-box">
    <div class="confirm-vehicle">
      <div class="vehicle-desc w-100%">
        <span class="mr10">{{ vehicleInfo.year }}</span>
        <span class="mr10">{{ vehicleInfo.make }}</span>
        <span class="mr10">{{ vehicleInfo.model }}</span>
      </div>
      <div v-if="vehicleInfo.type === 1" class="vehicle-info">
        <div class="vehicle-item">
          <span class="mr10">{{ vehicleInfo.trim }}</span>
          <span class="mr10">{{ vehicleInfo.engine }}</span>
        </div>
      </div>
      <div v-if="vehicleInfo.type === 2" class="vehicle-info">
        <div class="vehicle-item">
          <span class="mr10">{{ vehicleInfo.submodel }}</span>
        </div>
      </div>
    </div>
    <div class="car-img" :class="isPC ? 'pc-img': ''">
      <van-image width="100%" :src="vehicleInfo.image" />
    </div>
    <template v-if="isRepeat">
      <div class="desc-agree">
        <div class="text-left">
          <van-icon name="info" class="info-icon mr5" />
          <span>{{ $t('message.garage.vehicleAlreadyExit') }}</span>
        </div>
        <div class="text-left pl20">{{ $t('message.garage.plzAddNexVehicle') }}.</div>
        <van-button class="mt20" :class="isPC ? 'btn-style' : ''" type="primary" size="large" @click="goBack">
          {{ $t('message.garage.backToMyGarage') }}
        </van-button>
        <van-button class="mt20" :class="isPC ? 'btn-style' : ''" plain type="primary" size="large" @click="toSelectType">
          {{ $t('message.garage.addANewVehicle') }}
        </van-button>
      </div>
    </template>
    <template v-else>
      <div class="desc-agree">
        <van-checkbox :model-value="true">{{
          $t('message.garage.confirmVehicleWord')
        }}</van-checkbox>
      </div>
      <van-button :name="trackName" v-track-click class="mt20" :class="isPC ? 'btn-style' : ''" type="primary" size="large" @click="confirmVehicle">
        {{ $t('message.confirm') }}
      </van-button>
    </template>
  </div>
</template>
<script setup>
import Navbar from '@/components/navbar/navbar.vue'
import { useRouter } from 'vue-router'
import { useGarageStore } from '@/store/garage'

const router = useRouter()
const garageStore = useGarageStore()
const vehicleInfo = computed(() => garageStore.selectedCar)
const isRepeat = computed(() => {
  const { carList, selectedCar } = garageStore
  return carList.some((e) => e.vpid === selectedCar.vpid)
})

const isPC = computed(() => (garageStore.client === 'pc'))

const trackName = computed(() => {
  if (vehicleInfo.value.type === 1) {
    return 'btn_confirm_vehicle_car'
  }
  if (vehicleInfo.value.type === 2) {
    return 'btn_confirm_vehicle_motorcycle'
  }
})

const confirmVehicle = async () => {
  await garageStore.doAddMyCar()
  if (isPC.value) {
    window.parent.postMessage({ type: 'close', action: '', dataStr: '' }, '*')
  } else {
    router.push('/garage')
  }
}

const goBack = () => {
  if (isPC.value) {
    router.push('/selectGarageVehicle')
    // https://static-test.voghion.com/static/automotive/index.html#/selectGarageVehicle?client=pc
    // window.parent.postMessage({ type: 'close', action: '', dataStr: '' }, '*')
  } else {
    router.replace('/garage')
  }
}

const toSelectType = () => {
  router.replace('/vehiceltype')
}
</script>
<style lang="scss" scoped>
.confirm-vehicle {
  padding: 0 10px;
  .vehicle-desc {
    font-size: 18px;
    color: #111;
    margin-top: 20px;
    font-weight: bold;
  }
  .vehicle-info {
    font-size: 16px;
    color: #666;
  }
}
.car-img {
  padding: 10px 20px;
  text-align: center;
  &.pc-img {
    padding: 10px 20vw;
  }
}
.info-icon {
  color: #fdbb2b;
}
.confirm-vehicle-box {
  padding: 10px;
  .desc-agree {
    font-size: 14px;
    color: #666;
    text-align: center;
    padding: 0 10px;
  }
}
.btn-style {
  width: 90%;
  margin-left: 5%;
  height: 40px;
}
</style>
